<p-toast *ngIf="authenticated"></p-toast>
<router-outlet *ngIf="authenticated"></router-outlet>
